<template
  ><div class="gs-app gm-studio">
    <gs-modal
      v-model="open"
      class="gm-popup-form"
      title="Form"
      size="lg"
      hide-header
      @close="close"
      ><button
        type="button"
        class="gm-popup-form__close"
        aria-label="Close form"
        @click="dismiss"
      >
        <span aria-hidden="true">&times;</span></button
      ><public-form :form-id="formId" popup-mode
    /></gs-modal></div
></template>
<script>
import './index';
import PublicForm from './PublicForm.vue';
export default {
  components: { PublicForm },
  props: { formId: String },
  data: () => ({ open: false }),
  mounted() {
    this.open = true;
  },
  methods: {
    dismiss() {
      this.open = false;
      this.close();
    },
    close() {
      const origin = new URLSearchParams(window.location.search).get(
        'parentOrigin'
      );
      if (origin && /^https?:\/\//.test(origin))
        window.parent.postMessage({ type: 'groovemail:close-popup' }, origin);
    }
  }
};
</script>
